( function () {
	'use strict';

	function SegmentCard ( logger ) {
		var self = this;

		function activate () {
			logger.info( 'Activated SegmentCard View' );
		}

		function getImage () {
			return self.cardInfo.image;
		}

		function getTitle () {
			return self.cardInfo.templateTitle;
		}

		function getDescription () {
			return self.cardInfo.description;
		}

		function getGenBtn () {
			return self.cardInfo.genBtn;
		}

		self.Image       = getImage;
		self.Title       = getTitle;
		self.Description = getDescription;
		self.GenBtn      = getGenBtn;
		self.Generate    = self.generate;

		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'SegmentCard', SegmentCard );

	SegmentCard.$inject = [ 'logger' ];
} )();
